import { SkeletonInputWrapper } from '@shared/components'
import { Flex, Typography } from 'antd'

import type { TitleProps } from 'antd/es/typography/Title'
import type { PropsWithChildren, ReactNode } from 'react'

const { Title } = Typography

type Props = {
  title: string
  count?: number
  isLoading?: boolean
  extra?: ReactNode
  extraTitle?: ReactNode
} & PropsWithChildren &
  TitleProps

export const TitleSection = ({
  title,
  count,
  isLoading,
  children,
  extraTitle,
  extra,
  ...props
}: Props) => {
  return (
    <Flex justify="space-between" gap={20} className="title-section mb-16" wrap>
      <Flex align="center" gap={4}>
        <Title level={4} {...props}>
          {title} {!count && !isLoading}
        </Title>

        <SkeletonInputWrapper active={isLoading}>
          {!!count && <Title level={4}>{`(${count})`}</Title>}
          {extra && <Title level={4}>{extra}</Title>}
        </SkeletonInputWrapper>

        {extraTitle}
      </Flex>

      <Flex gap={8}>{children}</Flex>
    </Flex>
  )
}
